<template>
  <!-- 店铺信息-案例展示 -->
  <div class="Case-box">
    <div
      class="Case-presentation"
      v-for="(item, index) in listArr"
      :key="index"
    >
      <div class="Select-box" v-if="distinguish == 1">
        <el-checkbox
          v-model="item.choose"
          @change="handelChange(item)"
        ></el-checkbox>
      </div>
      <div class="Remainder firm-clickable" @click="handelEditCase(item)">
        <div class="item-name-box">
          <p class="item-name">洪驰供应链管理公司logo设计</p>
          <div class="item-type">
            <p>企业名称变更</p>
          </div>
        </div>
        <!-- 介绍 -->
        <div class="introduce">
          宏驰供应链管理公司委托我方设计logo品牌设计，当时我们形象化的将图形展示结合文字创意设计体现logo的实用性和美观度，图文结合的形式体现企业精神和目标为设计理念！
        </div>
        <!-- 金额 -->
        <div class="amount">3000元</div>
      </div>

      <!--  -->
      <div class="picture">
        <div class="picture-img"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
    distinguish: {}, // 区分是店铺编辑 还是帮帮展示  1店铺中使用   2帮帮中使用
    Clear: {},
  },
  data() {
    return {
      checked: "",
      idArr: [], // 选中项的id集
    };
  },
  watch: {
    // 监听 此数改变说明删除事件执行 清空选中  选中的id集合
    Clear: {
      handler(newSs, old) {
        // 清空id集
        this.idArr = [];
      },
      immediate: false,
    },
  },
  components: {},
  created() {},
  methods: {
    // 点击选中/取消选中 案例
    handelChange(item) {
      // 取消案例选中
      if (item.choose == false) {
        // 循环得到id集中取消选中案例的id所在位置
        for (var i in this.idArr) {
          if (this.idArr[i] == item.id) {
            // 从id集中将其删除
            this.idArr.splice(i, 1);
          }
        }
      } else {
        // 选中案例
        // 将选中案例的id放入选中id集中
        this.idArr.push(item.id);
      }
      setTimeout(() => {
        // 为确保数据的准确性  延时执行  将数据传给父组件
        this.$emit("handelChange", this.idArr);
      }, 100);
    },
    handelEditCase(item) {
      this.$emit("handelEditCase", item);
    },
  },
};
</script>

<style scoped lang="less">
.Case-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  .Case-presentation:hover {
    box-shadow: 0px 0px 3px 0px rgba(50, 145, 248, 0.8);
  }
  .Case-presentation {
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 10px 20px 10px 20px;
    display: flex;
    .Select-box {
      width: 15px;
      height: 15px;
      margin: auto 0;
      display: flex;
      /deep/.el-checkbox__inner {
        width: 15px;
        height: 15px;
        border: 1px solid #409eff ;
      }
    }
    .Remainder {
      flex: 1;
      display: flex;
    }
    // 项目名
    .item-name-box {
      min-width: 240px;
      height: 100%;
      margin-left: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      .item-name {
        max-width: 300px;
        font-size: 14px;
        color: #333333;
        margin: auto 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item-type {
        display: flex;
        height: 23px;
        line-height: 23px;
        margin: auto 0;
        p {
          min-width: 60px;
          padding-left: 5px;
          padding-right: 5px;
          font-size: 12px;
          color: #409eff ;
          text-align: center;
          background: rgba(97, 144, 232, 0.2);
          border: 1px solid #409eff ;
          border-radius: 5px;
        }
      }
    }
    // 介绍
    .introduce {
      width: 350px;
      min-height: 50px;
      max-height: 80px;
      margin: auto 0;
      margin-left: 50px;
      font-size: 12px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .amount {
      width: 120px;
      height: 30px;
      font-size: 20px;
      color: #fe574a;
      margin: auto 0;
      margin-left: 50px;
    }
    .picture {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      .picture-img {
        width: 150px;
        height: 100%;
        background: #eeeeee;
        border-radius: 10px;
      }
    }
  }
}
</style>
